var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgULockAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0095DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12V14.1C22.31 14.04 21.81 14.01 21.25 14V12C21.25 8.85 20.36 6.75 16 6.75C11.64 6.75 10.75 8.85 10.75 12V14C10.19 14.01 9.69 14.04 9.25 14.1V12C9.25 9.1 9.95 5.25 16 5.25C22.05 5.25 22.75 9.1 22.75 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26 19V21C26 25 25 26 21 26H11C7 26 6 25 6 21V19C6 15.66 6.7 14.41 9.25 14.1C9.69 14.04 10.19 14.01 10.75 14H21.25C21.81 14.01 22.31 14.04 22.75 14.1C25.3 14.41 26 15.66 26 19Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C11.87 21 11.74 20.97 11.62 20.92C11.49 20.87 11.39 20.8 11.29 20.71C11.11 20.52 11 20.26 11 20C11 19.87 11.03 19.74 11.08 19.62C11.13 19.5 11.2 19.39 11.29 19.29C11.39 19.2 11.49 19.13 11.62 19.08C11.99 18.92 12.43 19.01 12.71 19.29C12.8 19.39 12.87 19.5 12.92 19.62C12.97 19.74 13 19.87 13 20C13 20.26 12.89 20.52 12.71 20.71C12.52 20.89 12.26 21 12 21Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21C15.73 21 15.48 20.89 15.29 20.71C15.2 20.61 15.13 20.5 15.08 20.38C15.03 20.26 15 20.13 15 20C15 19.73 15.11 19.48 15.29 19.29C15.66 18.92 16.33 18.92 16.71 19.29C16.89 19.48 17 19.73 17 20C17 20.13 16.97 20.26 16.92 20.38C16.87 20.5 16.8 20.61 16.71 20.71C16.52 20.89 16.26 21 16 21Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21C19.74 21 19.48 20.89 19.29 20.71C19.11 20.52 19 20.27 19 20C19 19.73 19.11 19.48 19.29 19.29C19.67 18.92 20.34 18.92 20.71 19.29C20.75 19.34 20.79 19.39 20.83 19.45C20.87 19.5 20.9 19.56 20.92 19.62C20.95 19.68 20.97 19.74 20.98 19.8C20.99 19.87 21 19.94 21 20C21 20.26 20.89 20.52 20.71 20.71C20.52 20.89 20.26 21 20 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgULockAlt);
export default __webpack_public_path__ + "static/media/u_lock-alt.ecf08f5294112fdd20304c15062c3948.svg";
export { ForwardRef as ReactComponent };